// extracted by mini-css-extract-plugin
export default {"white":"#fff","verticalLine":"#d8d8d8","navbarTextColor":"#36495a","tableHeaderBg":"#1e4b82"};